import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import OutboundLink from '../../../../atoms/OutboundLink';

const ServicesBody = props => {
  const { services, bodyColor } = props;
  const serviceLength = services.length;
  const spaceColumns = Math.floor((16 - 2 - serviceLength * 4) / (serviceLength - 1));
  return (
    <Grid style={{ paddingBottom: '3em', paddingTop: '3em', backgroundColor: bodyColor }} centered>
      <Grid.Column computer={1} only="computer" />
      {services.map((service, index) => (
        <React.Fragment key={`footer-service-${service.title}`}>
          <Grid.Column tablet={2} only="tablet" />
          <Grid.Column computer={4} tablet={12}>
            <div
              style={{
                textAlign: 'center',
                fontSize: '1.3em',
                fontWeight: 'bold',
                paddingBottom: '.5em',
              }}
            >
              <OutboundLink to={service.link} label={service.title} />
            </div>
            <div>{service.content}</div>
          </Grid.Column>
          <Grid.Column tablet={2} only="tablet" />
          {index !== serviceLength - 1 ? (
            <Grid.Column computer={spaceColumns} only="computer" />
          ) : (
            <Grid.Column computer={1} only="computer" />
          )}
        </React.Fragment>
      ))}
    </Grid>
  );
};

ServicesBody.propTypes = {
  bodyColor: PropTypes.string.isRequired,
};

export default ServicesBody;
